enum PLATFORM_MAPPING {
    YOUTUBE_CHANNEL = 'epic.affiliate.social.channels.dropdown.youtube',
    TWITCH_CHANNEL = 'epic.affiliate.social.channels.dropdown.twitch',
    FACEBOOK = 'epic.affiliate.social.channels.dropdown.facebook',
    VK = 'epic.affiliate.social.channels.dropdown.vk',
    TWITTER = 'epic.affiliate.social.channels.dropdown.twitter',
    INSTAGRAM = 'epic.affiliate.social.channels.dropdown.instagram'
    // TIKTOK = 'epic.affiliate.social.channels.dropdown.tiktok'
}

export default PLATFORM_MAPPING;
